"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = nullthrows;

// This is essentially a special case of `invariant` for null values.
function nullthrows(x) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Got unexpected null or undefined.';

  if (x == null) {
    throw new Error(message);
  }

  return x;
}